/** Canvas2D background: starfield, breakout tiles, world-edge fill. */
import { breakoutTileRgb } from '../../render_utils.js';

/**
 * @param {import('../../renderer.js').Canvas2DRenderer} r
 * @param {number} timePassed
 */
export function renderBackground(r, timePassed) {
    var i, bs;

    // Clear the entire physical canvas to transparent so letterbox/pillarbox bands
    // show the black page background rather than the game background colour.
    const bgCanvas = r.bgContext.canvas;
    r.bgContext.save();
    r.bgContext.setTransform(1, 0, 0, 1, 0, 0);
    r.bgContext.clearRect(0, 0, bgCanvas.width, bgCanvas.height);
    r.bgContext.restore();

    // Fill only the game footprint with the dark game background.
    // Uses the game transform (already set by setScaleFactor) so the fill is
    // automatically clipped to the game area regardless of orientation.
    r.bgContext.fillStyle = "#191919";
    r.bgContext.fillRect(0, 0, r.gridSystem.width, r.gridSystem.height);

    const bgZoom = r.game.getLevelZoomScale ? r.game.getLevelZoomScale() : 1;
    if (bgZoom !== 1) r._pushLevelZoom(r.bgContext, bgZoom);

    // Clamp timePassed so stars don't jump after the game was paused.
    const starDt = Math.min(timePassed, 1 / 30);

    for (i = 0; i < r.backgroundStars.length; i += 1) {
        bs = r.backgroundStars[i];

        bs[0] += starDt * bs[2] / 20;

        if (bs[0] > r.gridSystem.width) {
            bs[0] = bs[0] % r.gridSystem.width;
        }

        // Star brightness never changes — build its color string once (slot 3)
        // instead of allocating 500 template strings per frame.
        r.bgContext.fillStyle = bs[3] ?? (bs[3] = `rgb(${bs[2]},${bs[2]},${bs[2]})`);
        r.bgContext.fillRect(bs[0], bs[1], 1, 1);
    }

    renderBreakoutTiles(r);

    if (bgZoom !== 1) r.bgContext.restore();
}

/**
 * @param {import('../../renderer.js').Canvas2DRenderer} r
 */
export function renderBreakoutTiles(r) {
    const tiles = r.game.getBreakoutTiles();
    if (!tiles || tiles.length === 0) return;
    const tileSize = r.game.getBreakoutTileSize();
    r.bgContext.save();
    for (let i = 0; i < tiles.length; i += 1) {
        const tile = tiles[i];
        // Tile color only changes when it takes a hit — cache the rgba string
        // on the tile instead of recomputing it per tile per frame.
        if (tile._rgbaStr === undefined || tile._rgbaHits !== tile.hitCount) {
            const [red, grn, blu] = breakoutTileRgb(tile);
            tile._rgbaStr  = `rgba(${red}, ${grn}, ${blu}, 0.85)`;
            tile._rgbaHits = tile.hitCount;
        }
        r.bgContext.fillStyle = tile._rgbaStr;
        r.bgContext.fillRect(tile.x, tile.y, tileSize, tileSize);
    }
    r.bgContext.restore();
}

/**
 * @param {import('../../renderer.js').Canvas2DRenderer} r
 */
export function renderBorder(r) {
    r.context.fillStyle = '#000';
    r.context.fillRect(r.gridSystem.width, 0, 500, r.gridSystem.height + 500);
    r.context.fillRect(0, r.gridSystem.height, r.gridSystem.width + 500, 500);
}
